import ComponentsFactory from 'foundation/components-factory';
import ImgeGallery from './js/image-gallery.component';
import './scss/index.scss';

ComponentsFactory.getInstance().define('image-gallery', ImgeGallery);
